module.exports = __webpack_public_path__ + "img/16.b63360b5.jpg";